import {pathTranslations, reverseSegmentTranslations} from "../i18n/routing";

/**
 * Converts localized URL segments back to their canonical form
 * Example: "/referenzen" (de) → "/referenties" (canonical)
 */
export function reverseTranslateSegments(path, lang) {
    if (!path || !lang) return path || '/';
    
    const segments = path.split('/').filter(Boolean);
    const reversedSegments = segments.map(segment => {
        return reverseSegmentTranslations[lang]?.[segment] || segment;
    });
    return '/' + reversedSegments.join('/');
}

/**
 * Translates canonical segments into localized equivalents
 * Example: "/referenties" (canonical) → "/references" (en)
 */
export function translateSegments(path, lang) {
    if (!path || !lang) return path || '/';
    
    if (typeof path !== 'string') {
        path = path.pathname || '';
    }
    
    const segments = path.split('/').filter(Boolean);
    const translatedSegments = segments.map(segment => {
        return pathTranslations[segment]?.[lang] || segment;
    });
    return '/' + translatedSegments.join('/');
}

